<template>
  <vx-card :id="`question-card_${answer.questionId}`" v-show="isCardActiveLocal" :style="{ 'background-color': question && question.quizDetails.isGraded ? answer && answer.questionAchievedMarks == answer.questionTotalMarks ? 'rgba(107, 255, 81, 0.3)' : 'rgba(255, 56, 56, 0.3)' : 'none', 'margin-bottom': '1rem' }">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h5 class="mb-2">{{ answer.questionNumber }}. {{ questionTitle }}</h5>
        <p class="mb-2" style="word-break: break-word;">{{ questionText }}</p>
        <div v-if="answer.imageUrl" class="vx-row mb-3">
          <div class="vx-col w-full">
            <img :src="answer.imageUrl" height="200px" alt="Question Image">
          </div>
        </div>
        <ul>
          <div class="draggable-images-quiz-result">
            <div v-for="(location, index) in answer.dragAndDropMapLocations" :key="index">
              <img :style="(location.xCoordinate == location.selectedXCoordinate) && (location.yCoordinate == location.selectedYCoordinate) 
                                                ? 'box-shadow: 1px 1px 1px 1px #28C76F;' : 'box-shadow: 1px 1px 1px 1px #EA5455;'" 
                                                :src="location.draggableImageUrl" style="width: 50px">
              <div v-if="(location.xCoordinate == location.selectedXCoordinate) && (location.yCoordinate == location.selectedYCoordinate)">
                Correct
              </div>
              <div v-else>
                Wrong
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>
    <comment-view :isCardActive="commentView" :question="question" :answer="answer" />
  </vx-card>
</template>

<script>
  import commentView from './QuizCommentView.vue';
  export default {
    components: {
      commentView
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      answer: {
        type: Object,
        required: false
      },
    },
    data() {
      return {
        commentView: true,
        questionText: "",
        questionTitle: ""
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.question){

          }else{
            self.initValues();
          }
        }
      },
      question: function(val) {
        if(val){
          this.commentView = true;
        }
      }
    },
    methods: {
      strip(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      },
      initValues() {
        this.errors.clear();
      },
    },
    mounted() {
      if(this.answer){
        this.questionText = this.strip(this.answer.questionText);
        this.questionTitle = this.strip(this.answer.questionTitle);
      }
    }
  }

</script>

<style lang="scss">
  .draggable-images-quiz-result{
    display: flex;
    overflow-x: auto;
    width: 100%;

    div{
      margin-right: 4px;
    }
  }
</style>
